import React, { useState } from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";
// import { Dropdown, Badge } from "react-bootstrap";
// import api from "services/api";
// import auth from "services/auth";
// import AppContext from "contexts/AppContext";
import LoggedInNav from "elements/LoggedInNav";

export default function SideNav(props) {
  const [avtiveMenu, setActiveMenu] = useState("");
  const changeTab = (tab) => {
    if (avtiveMenu === tab) {
      setActiveMenu("");
    } else {
      setActiveMenu(tab);
    }
  };

  return (
    <>
      <div class={"sidebar_wrapper " + props.landingType}>
        <div className="sidebar_heading">{__("Games")}</div>
        <ul className="">
          <li className="list-heading">
            <Link
              className={avtiveMenu === "games" ? "active" : ""}
              onClick={() => changeTab("games")}
            >
              <span>Games</span>
              <i
                class={
                  avtiveMenu === "games"
                    ? "far fa-chevron-up"
                    : "far fa-chevron-down"
                }
              ></i>
            </Link>
            <div
              className={
                avtiveMenu === "games" ? "collapse-menu show" : "d-none"
              }
            >
              <ul>
                <li className="list-item">
                  <Link to="/games/slots" className={props.landingType}>
                    {__("All Games")}
                  </Link>
                </li>
                <li className="list-item">
                  <Link to="/games/popular" className={props.landingType}>
                    {__("Popular")}
                  </Link>
                </li>
                <li className="list-item">
                  <Link to="/games/provably-fair" className={props.landingType}>
                    {__("Provably Fair")}
                  </Link>
                </li>
                <li className="list-item">
                  <Link to="/games/new" className={props.landingType}>
                    {__("New")}
                  </Link>
                </li>
                <li className="list-item">
                  <Link to="/games/live-casino" className={props.landingType}>
                    {__("Live Casino")}
                  </Link>
                </li>
                <li className="list-item">
                  <Link to="/games/megaways" className={props.landingType}>
                    {__("Megaways")}
                  </Link>
                </li>

                <li className="list-item">
                  <Link to="/games/table-games" className={props.landingType}>
                    {__("Table Games")}
                  </Link>
                </li>

                <li className="list-item">
                  <Link to="/games/jackpot" className={props.landingType}>
                    {__("Jackpot")}
                  </Link>
                </li>

                <li className="list-item">
                  <Link to="/games/bonus-buy" className={props.landingType}>
                    {__("Bonus Buy")}
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        {props.isAuthenticated && <LoggedInNav {...props} />}
      </div>
    </>
  );
}
